export default "__VITE_ASSET__D_$PVh2$__"